import { ActionTypes } from "store/constants";


export const addWordBank = (returnedPayload) => ({ type: ActionTypes.wordBank.addWordBank, payload: returnedPayload });
export const setWordBank = (returnedPayload) => ({ type: ActionTypes.wordBank.setWordBank, payload: returnedPayload });
export const deleteWordBank = (returnedPayload) => ({type: ActionTypes.wordBank.deleteWordBank, payload: returnedPayload})
export const updateWordBank = (returnedPayload) => ({type: ActionTypes.wordBank.updateWordBank, payload: returnedPayload})